import * as pConsts from '../consts/profiles-consts';
import * as wConst from '../consts/website-consts';
import * as wActs from "./website-actions";
import * as sActs from "./search-actions";
import { fetch, addTask } from "domain-task";

export function getProfiles(page,pageSize) {
  return (dispatch, getState) => {
    let state = getState();

    let query = "";
    let place = "/";


    let qStr = "";
    if (typeof document !== "undefined") {
      qStr = document.location.toString();
      place = document.location.pathname;
    } else {
      qStr = state.Website.ServerParams.Query;
      place = state.Website.ServerParams.Path;
    }

    qStr = "http://www.fakeurl.com/" + qStr;
    let qInc = wActs.getParameterByName("include", qStr);
    let qExc = wActs.getParameterByName("exclude", qStr);

    page = wActs.getParameterByName("page", qStr);
    if(page === null) { page = "1"; }
    if(isNaN(parseInt(page))) { page = "1"; }

    let includes = "";
    let excludes = "";
    if (qInc != null) {
      includes += qInc;
      if (qExc != null) excludes += qExc;
    } else {
      let pth = state.Website.Page.Settings;
      if (typeof pth.Include !== "undefined") { includes += pth.Include; }
      if (typeof pth.Exclude !== "undefined") { excludes += pth.Exclude; }
    }

    let fltr = state.ProfilesList.Filter;
    if (typeof fltr !== "undefined") {
      if (!wActs.isNullOrEmpty(fltr.Include)) {
        includes += "," + fltr.Include;
      }
      if (!wActs.isNullOrEmpty(fltr.Exclude)) {
        excludes += "," + fltr.Exclude;
      }
    }

    //Remove Any Not Needed Commas, And Encode The Values
    if(includes.startsWith(",")) {includes = includes.substr(1);}
    if(excludes.startsWith(",")) {excludes = excludes.substr(1);}
    includes = encodeURIComponent(includes); excludes = encodeURIComponent(excludes);

    if (!wActs.isNullOrEmpty(includes)) {
      query += "&include=" + includes;
    }
    if (!wActs.isNullOrEmpty(excludes)) {
      query += "&exclude=" + excludes;
    }

    let srch = state.ProfilesList.Search;
    let doSearch = false;
    if (typeof srch !== "undefined" && srch !== "" && srch !== null) {
      query += "&relevant=false&term=" + encodeURIComponent(srch);
      doSearch =true;
    } else {
      srch = wActs.getParameterByName("term", qStr);
      if (typeof srch !== "undefined" && srch !== "" && srch !== null) {
        query += "&relevant=false&term=" + encodeURIComponent(srch);
        doSearch =true;
      }
    }

    //if(doSearch) {
    //  return dispatch(sActs.DoSearch(srch))
    //}

    let ref = "";
    if (typeof window !== "undefined") {
      ref = wActs.GetReferer();
    } else {
      ref = state.Website.ServerParams.Referer;
    }
    let finalQry = `?page=${page}&pagesize=${pageSize}${query}`;
    if(state.ProfilesList.LastQuery === finalQry) { //Same Shit, Fire With Cache
      dispatch({ type: pConsts.ACTION_FETCH_PROFILES_FULLFILLED, payload: state.ProfilesList.ProfilesData });
      return;
    }
    dispatch({ type: pConsts.ACTION_FETCH_PROFILES_PENDING, payload: finalQry });
    let pros = fetch(`${wConst.ROOT_URL(state.Website.Settings.ApiUrl)}/profiles${finalQry}`, { headers: { 'X-Alt-Referer': ref } })
      .then(resp => resp.json())
      .then(function (data) {
        dispatch({ type: pConsts.ACTION_FETCH_PROFILES_FULLFILLED, payload: data });
        //console.log("IN GET PROFILES SERVER SIDE? 3333333333");
      })
      .catch(function (ex) {
        console.log("Error calling get profiles:" + finalQry,ex);
      }
      );
    addTask(pros);
    return pros;
  };
}

export function searchProfiles(srch) {
  return (dispatch) => {
    dispatch({type: pConsts.ACTION_SEARCH_PROFILES, payload: srch});
    return(dispatch(getProfiles(1,pConsts.FILTER_PAGESIZE)));
  }
}


export function changeProfiles() {
  return function(dispatch, getState) {
    let state = getState();
    state.ProfilesList.Search = "";
    //eval('$("#search-text").val("")');
    //eval('$("#search-text-mobile").val("")');
    return dispatch(getProfiles(1,pConsts.FILTER_PAGESIZE));
  }
}

export function getProfile(id) {
  return function(dispatch,getState) {
    dispatch({type: pConsts.ACTION_FETCH_PROFILE_PENDING, payload: true});
    let ref = wActs.GetReferer();

    fetch(`${wConst.ROOT_URL(getState().Website.Settings.ApiUrl)}/profiles/${id}/page`, {headers: {'X-Alt-Referer': ref}})
      .then(resp => resp.json())
      .then(function(data) {
        dispatch({type: pConsts.ACTION_FETCH_PROFILE_FULLFILLED, payload: data});
      })
      .catch(function(ex, ex1) {
          console.log(ex);
        }
      );
  };
}


export function filterProfiles(filter) {
  return (dispatch) => {
    dispatch({ type: pConsts.ACTION_FILTER_PROFILES, payload: filter });
    return (dispatch(getProfiles(1, pConsts.FILTER_PAGESIZE)));
  };
}

